import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React, { PropsWithChildren } from 'react'
import Theme from 'core/themes/model'
import Text from '../Text'

type Props = PropsWithChildren<{
  className?: string
  bottomContent?: JSX.Element[]
}> &
  React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>

export default function NavPane({
  className,
  title,
  children,
  bottomContent = undefined,
  ...rest
}: PropsWithChildren<Props>) {
  const hasTitle = !!title
  const classes = useStyles()
  return (
    <nav
      className={clsx(classes.navPane, className, { [classes.navPaneWithTitle]: hasTitle })}
      {...rest}
    >
      {hasTitle && (
        <Text variant="subtitle2" component="h6" className={classes.navPaneTitle}>
          {title}
        </Text>
      )}

      <ul>{children}</ul>

      {!!bottomContent && <ul>{bottomContent}</ul>}
    </nav>
  )
}

type StyleProps = {
  title: boolean
}
const useStyles = makeStyles<Theme>((theme) => ({
  navPane: {
    display: 'grid',
    gridTemplateRows: '1fr max-content',
    paddingBottom: 16,
    '& ul': {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
  },
  navPaneWithTitle: {
    gridTemplateRows: 'max-content 1fr max-content',
  },
  navPaneTitle: {
    color: theme.components.sidebar.activeText,
  },
}))
